"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableAnchoredObjectsHolder = void 0;
var tslib_1 = require("tslib");
var TableAnchoredObjectsHolder = (function () {
    function TableAnchoredObjectsHolder() {
        this.holder = new Map();
    }
    TableAnchoredObjectsHolder.prototype.addTableCellAnchoredObject = function (tblPos, anchObjId) {
        var keys = this.holder.keys();
        var pos = keys.next();
        while (!pos.done) {
            if (pos.value.equals(tblPos)) {
                var anchObjIds = this.holder.get(pos.value);
                if (anchObjIds.indexOf(anchObjId) < 0)
                    anchObjIds.push(anchObjId);
                return;
            }
            pos = keys.next();
        }
        this.holder.set(tblPos.clone(), [anchObjId]);
    };
    TableAnchoredObjectsHolder.prototype.getTableCellAnchoredObjects = function (tblPos, formatter) {
        var keys = this.holder.keys();
        var pos = keys.next();
        while (!pos.done) {
            if (pos.value.equals(tblPos))
                return this.holder.get(pos.value).map(function (id) { return formatter.layoutPosition.page.anchoredObjectHolder.getObjById(id); });
            pos = keys.next();
        }
        return [];
    };
    TableAnchoredObjectsHolder.prototype.shallowCopy = function () {
        var obj = new TableAnchoredObjectsHolder();
        this.holder.forEach(function (v, k) { return obj.holder.set(k.clone(), tslib_1.__spreadArray([], v)); });
        return obj;
    };
    return TableAnchoredObjectsHolder;
}());
exports.TableAnchoredObjectsHolder = TableAnchoredObjectsHolder;
